import { CURRENCY, ICurrency, IUser, WALLET_CODE } from '.';
import {
  AFFILIATE_FORM_STATE,
  AFFILIATE_STATE,
  REFERRAL_STATE,
  ENUM_USER_STATE,
  AFFILIATE_COMMISION_STATE,
  AFFILIATE_MODE,
} from './enums';
export interface IPlayerReward {
  _id?: string;
  user_id: string;
  referral_id: string;
  state: REFERRAL_REWARD_STATE;
  deposited: number;
  bonus: number;
  betted: number;
  docs: boolean;
  percentage: number;
  createdAt: number;
  settledAt?: number;
  email: string;
  wallet: WALLET_CODE;
}
export interface IRewardAnalisys {
  wallet: string;
  factor_dub: number;
  factor_sport: number;
  factor_games: number;
  rewardAmount: number;
  hasDeposit: boolean;
  docsUploaded: boolean;
  totalBetGamesAmount: number;
  totalBetSportsAmount: number;
  totalBeDubsAmount: number;
  totalRewardAmount: number;
  canApply: boolean;
  percentageAcomplish: number;
}
export enum REFERRAL_REWARD_STATE {
  PENDING = 'PENDING',
  REVIEW = 'REVIEW',
  SETTLED = 'SETTLED',
}
export interface IReferral {
  affiliate_id: string;
  user_id: string;
  state: REFERRAL_STATE;
}
export interface IAffiliateModel {
  type: AFFILIATE_MODE;
  first_deposit_perc: number;
  monthly: number;
  duration: number;
  pt: string;
  es: string;
  en: string;
}
export interface IAffiliateCurrency {
  currency: CURRENCY | ICurrency;
  total_equity: number;
  pending_equity: number;
  last_timestamp_commit: number;
}
export interface IAffiliateData {
  state: AFFILIATE_STATE;
  timestamp: number;
  code: string;
  visitors: IAffiliateVisitors;
  // currencies: IAffiliateCurrency[];
  model: AFFILIATE_MODE;
}
export interface IAffiliateVisitors {
  visitors: number;
  signup: number;
  deposits: number;
  timestamps: IAffiliateTimestamps[];
}
export interface IAffiliateTimestamps {
  timestamp: number;
  visitors: number;
}
export interface IAffilaiteForm {
  _id?: string;
  user_id: string;
  desc: string;
  name: string;
  email: string;
  type: 'app' | 'bussines' | 'digital';
  url: string;
  created_at: number;
  state: AFFILIATE_FORM_STATE;
  user?: IUser;
  model?: AFFILIATE_MODE;
}
export interface IUserAffiliate {
  _id: string;
  image_id: string;
  name: string;
  userName: string;
  timestamp?: number;
  state: ENUM_USER_STATE;
  affiliateData: IAffiliateData;
  model: IAffiliateModel;
  highlight?: boolean;
  removeConn?: boolean;
  conns?: number;
  bets?: number;
  balance?: any;
}
export interface IAffiliateReferralCommission {
  _id?: string;
  affiliate_id: string;
  type: AFFILIATE_MODE;
  currency: CURRENCY;
  deposit_id: string;
  referral_id: string;
  amount: number;
  timestamp: number;
  settled?: number;
  isFirstDeposit: boolean;
}
export interface IMonthlyeReferralCommission {
  _id: string;
  affiliate_id: string;
  affiliateReferralCommission_ids: string[];
  amount: number;
  currency: CURRENCY;
  state: AFFILIATE_COMMISION_STATE;
  timestamp: number;
}
export interface IAffiliateMonthly {
  affiliate_id: string;
  start_date: number;
  end_date: number;
  deposits: number;
  signups: number;
  visitors: number;
  currencies?: any[];
  commissions: number;
}
